import { Fancybox } from "@fancyapps/ui";
import InfiniteMarquee from "vanilla-infinite-marquee";
import AOS from "aos";

import "./modules/Header";
import "./modules/Slider";
import "./modules/Tab";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/ProjectDetail";
import "./modules/Capability";
import "./modules/CountUp";
import scrollToElement from "./modules/ScrollElement";
import SVGInjector from "svg-injector";

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$(function () {
	try {
		// Elements to inject
		var mySVGsToInject = document.querySelectorAll("img.inject-me");

		// Do the injection
		SVGInjector(mySVGsToInject);
	} catch (error) {}

	const infiniteMarquee = new InfiniteMarquee({
		element: document.querySelector(".infinite-marquee"),
		speed: 100000,
		gap: "2rem",
	});

	addFirstColumnClass();
	$(window).resize(function () {
		addFirstColumnClass();
	});

	AOS.init({
		duration: 1100,
		easing: "ease-out-back",
		disable: "mobile",
		offset: $(".global-header").height(),
		anchorPlacement: "top-center",
	});

	try {
		var spy = new Gumshoe(".scroll-nav-list a", {
			offset: function () {
				return (
					$(".global-header").height() +
					$(".scroll-nav-list").outerHeight() +
					parseFloat($("section[id*='about-']").css("paddingTop"))
				);
			},
			events: true,
		});
	} catch {}

	$(".anchor-link").on("click", function (e) {
		e.preventDefault();
		let href = $(this).attr("href");
		scrollToElement(href, 1000, $(".global-header").height());
	});
});

function addFirstColumnClass() {
	const row = $(".row-computed");
	let currentTopPosition = null;

	row.find("> *")
		.removeClass("first-column")
		.each(function () {
			const itemTopPosition = $(this).position().top;

			if (
				currentTopPosition === null ||
				itemTopPosition > currentTopPosition
			) {
				currentTopPosition = itemTopPosition;
				$(this).addClass("first-column");
			}
		});
}
